<template>
  <div class="_toolbar">
    <el-select
      style="width: 150px; margin-right: 10px;"
      name=""
      size="mini"
      id=""
      v-model="data.fontFamily"
    >
      <el-option
        :value="item.title"
        v-for="item in fonts"
        :key="item.id"
        :label="item.title"
      >
        <span :style="{ fontFamily: item.title }">{{ item.title }}</span>
      </el-option>
    </el-select>

    <el-input-number
      size="mini"
      v-model="data.fontSize"
      style="margin-right: 10px;"
    ></el-input-number>
    <el-color-picker
      size="mini"
      v-model="data.color"
      style="margin-right: 10px;"
    ></el-color-picker>
    <el-button-group style="margin-right: 10px;">
      <el-button
        size="mini"
        round
        :type="data.textAlign == 'left' ? 'primary' : ''"
        icon="fas fa-align-left"
        @click="data.textAlign = 'left'"
      ></el-button>
      <el-button
        size="mini"
        round
        :type="data.textAlign == 'center' ? 'primary' : ''"
        icon="fas fa-align-center"
        @click="data.textAlign = 'center'"
      ></el-button>
      <el-button
        size="mini"
        round
        icon="fas fa-align-right"
        :type="data.textAlign == 'right' ? 'primary' : ''"
        @click="data.textAlign = 'right'"
      ></el-button>
    </el-button-group>

    <el-button-group style="margin-right: 10px;">
      <el-button
        size="mini"
        round
        icon="fas fa-bold"
        :type="data.fontWeight == 'bold' ? 'primary' : ''"
        @click="data.fontWeight = data.fontWeight == 'bold' ? 'normal' : 'bold'"
      ></el-button>
      <el-button
        size="mini"
        round
        icon="fas fa-italic"
        :type="data.fontStyle == 'italic' ? 'primary' : ''"
        @click="
          data.fontStyle = data.fontStyle == 'italic' ? 'normal' : 'italic'
        "
      ></el-button>
      <el-button
        size="mini"
        round
        icon="fas fa-underline"
        :type="data.textDecoration == 'underline' ? 'primary' : ''"
        @click="
          data.textDecoration =
            data.textDecoration == 'underline' ? 'none' : 'underline'
        "
      ></el-button>
    </el-button-group>
  </div>
</template>

<script>
export default {
  name: "TextToolbar",
  props: ["data", "fonts"],
  data() {
    return {};
  },
};
</script>
<style>
._toolbar {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/TextToolbar.vue